import React from "react";
import { Table, Drawer } from "antd";
import { MdEdit, MdDelete } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteSelectedProduction,
  setSelectedProduction,
  toggleNewEditDialog,
} from "../store/stateSlice";
import dayjs from "dayjs";

const ProductionTable = ({ handleRefresh }) => {
  const dispatch = useDispatch();
  const data = useSelector(
    (state) => state.production.state.selectedproduction
  );

  const onEdit = (record) => {
    dispatch(
      setSelectedProduction({
        ...record,
        Worker: [
          {
            worker_name: record?.Worker?.worker_name,
            worker_id: record?.Worker?.worker_id,
          },
        ],
      })
    );
  };
  const onDelete = (index) => {
    dispatch(deleteSelectedProduction(index));
  };

  const columns = [
    {
      title: <span className="text-gray-500">Action</span>,
      dataIndex: "action",
      width: 100,
      fixed: "left",
      render: (_, record, index) => (
        <div className="flex items-center">
          <span
            onClick={() => onEdit(record)}
            className="text-2xl text-[#096CAE] cursor-pointer"
          >
            <MdEdit />
          </span>
          <span
            onClick={() => onDelete(index, record)}
            className="text-2xl text-[#cf1623] cursor-pointer"
          >
            <MdDelete />
          </span>
        </div>
      ),
    },
    {
      title: <span className="text-gray-500">Product</span>,
      dataIndex: ["Product", "part_name"],
      width: 150,
    },
    {
      title: <span className="text-gray-500">From Date to Date</span>,
      dataIndex: "fromDateToDate",
      width: 150,
      render: (_, record) => `${record?.start_date} to ${record?.end_date}`,
    },
    {
      title: <span className="text-gray-500">Processes</span>,
      dataIndex: ["Process", "process_name"],
      width: 150,
    },
    {
      title: <span className="text-gray-500">Employee Name</span>,
      dataIndex: ["Worker", "worker_name"],
      width: 150,
      render: (_, record) => record.Worker?.worker_name,
    },
    {
      title: <span className="text-gray-500">Quantity</span>,
      dataIndex: "quantity",
      width: 150,
    },
    {
      title: <span className="text-gray-500">Description</span>,
      dataIndex: "description",
      width: 150,
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        bordered
        scroll={{ x: 1300 }}
      />
    </>
  );
};

export default ProductionTable;
